var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSoundOn = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 0.678748L3.15 2.87875H0.6C0.25 2.87875 0 3.15375 0 3.47875V7.07875C0 7.42875 0.25 7.67875 0.6 7.67875H3.15L5.375 9.90375C5.75 10.2787 6.4 10.0287 6.4 9.47875V1.10375C6.4 0.553748 5.75 0.303748 5.375 0.678748ZM12 5.27875C12 3.70375 11.175 2.25375 9.85 1.37875C9.575 1.20375 9.2 1.27875 9.025 1.57875C8.85 1.85375 8.925 2.22875 9.2 2.40375C10.2 3.02875 10.8 4.12875 10.8 5.27875C10.8 6.45375 10.2 7.55375 9.2 8.17875C8.925 8.35375 8.85 8.72875 9.025 9.00375C9.175 9.27875 9.55 9.37875 9.85 9.20375C11.175 8.32875 12 6.87875 12 5.27875ZM8.45 3.37875C8.15 3.20375 7.8 3.30375 7.625 3.60375C7.475 3.90375 7.575 4.25375 7.875 4.42875C8.175 4.60375 8.4 4.92875 8.4 5.27875C8.4 5.65375 8.175 5.97875 7.875 6.15375C7.575 6.32875 7.475 6.67875 7.625 6.97875C7.8 7.27875 8.15 7.37875 8.45 7.20375C9.15 6.82875 9.6 6.07875 9.6 5.27875C9.6 4.50375 9.15 3.75375 8.45 3.37875Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSoundOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/soundOn.a01a1a755267db5de7337904c06c8b7e.svg";